module.exports = require('./helpers/bundle-url').getBundleURL('43Ydi') + "logo.7718c6df.svg";